<div class="row mb-product-line px-3 py-3 mb-3">
  <div class="col-4 col-md-3 px-2 my-auto">
    <cx-media
      [container]="wishlistEntry?.product?.images?.PRIMARY"
      format="thumbnail"
      alt="{{wishlistEntry?.product?.name}}">
    </cx-media>
  </div>
  <div class="col-8 col-md-9 px-2">
    <div class="row no-gutters h-100">
      <div class="d-flex flex-column col-md-7 col-xl-8">
        <div>
          <span>{{wishlistEntry?.product?.code}}</span>
        </div>
        <div>
          <span class="mb-cart-item-pdp-link" (click)="navigateToPdp(wishlistEntry.product?.code)">
              <strong [innerHTML]="wishlistEntry.product?.nameHtml | safeHtml"></strong>
          </span>
        </div>
        <div>
          <p></p>
        </div>
        <div>
          <span class="mr-5" [innerHTML]="'mbcommon.price' | cxTranslate"></span>
          <div *ngIf="!hasPriceOnRequest; else onRequest">
            <strong [innerHTML]="wishlistEntry.product?.baseOptions?.[0]?.selected?.priceData?.formattedValue | safeHtml"></strong>
          </div>
          <ng-template #onRequest>
            <strong [innerHTML]="'mbcommon.onRequest' | cxTranslate"></strong>
          </ng-template>
        </div>
      </div>
      <div class="col-md-5 col-xl-4 my-auto">
        <button type="button"
                class="btn btn-sm mb-remove-wishlist-btn mb-1 mt-md-2 mt-lg-0 float-right"
                mbOneClickAllowed
                (click)="removeEntry(wishlistEntry?.product?.code)"
                data-cy="mb-remove-from-wishlist">
          <img src="/assets/icons/svg/wishlist-heart-filled.svg"
               [title]="'mbMyAccount.wishlist.remove' | cxTranslate"
               [alt]="'mbMyAccount.wishlist.remove' | cxTranslate"/>
        </button>
        <mb-add-to-cart [addToCartForm]="addToCartForm"
                        [hasPriceOnRequest]="hasPriceOnRequest"
                        [product]="wishlistEntry?.product"
                        [clickSource]="dataAnalyticsClickSource"
                        class="float-right"
                        [productCode]="wishlistEntry?.product?.code">
        </mb-add-to-cart>
      </div>
    </div>
  </div>
</div>
